import type { ICard } from "../cardsSlice";
import { major0Card } from "./major/major_0";
import { major1Card } from "./major/major_1";
import { major2Card } from "./major/major_2";
import { major3Card } from "./major/major_3";
import { major4Card } from "./major/major_4";
import { major5Card } from "./major/major_5";
import { major6Card } from "./major/major_6";
import { major7Card } from "./major/major_7";
import { major8Card } from "./major/major_8";
import { major9Card } from "./major/major_9";
import { major10Card } from "./major/major_10";
import { major11Card } from "./major/major_11";
import { major12Card } from "./major/major_12";
import { major13Card } from "./major/major_13";
import { major14Card } from "./major/major_14";
import { major15Card } from "./major/major_15";
import { major16Card } from "./major/major_16";
import { major17Card } from "./major/major_17";
import { major18Card } from "./major/major_18";
import { major19Card } from "./major/major_19";
import { major20Card } from "./major/major_20";
import { major21Card } from "./major/major_21";

export const majorArcanesData: ICard[] = [
  major0Card,
  major1Card,
  major2Card,
  major3Card,
  major4Card,
  major5Card,
  major6Card,
  major7Card,
  major8Card,
  major9Card,
  major10Card,
  major11Card,
  major12Card,
  major13Card,
  major14Card,
  major15Card,
  major16Card,
  major17Card,
  major18Card,
  major19Card,
  major20Card,
  major21Card,
];


